import { gmiRequest } from 'actions/request';
import { actions, services } from '@ehi/global-marketing-interface';
import utils from 'utils';

/**
 * login description
 * gmi service call to pass along login credentials and authenticate the user
 *
 * @param {object} params
 * @param {string} params.username - username or email address
 * @param {string} params.password - password
 * @param {boolean} params.remember_credentials -

 * @return {Promise}
 */
export const login = payload => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        data: {
          payload,
        },
        service: services.gma.profile.login,
      }),
    })
  );

// attempts to log the user in without their username and password.
// this will read a browser cookie instead
// and should only fire if the user is logged out and "remember_me_eligible" is true
// if the user previously logged in and chose "remember_credentials", this should activate upon their next visit after their session expired
export const loginRememberMe = () => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.profile.loginRememberMe,
      }),
    })
  );

/**
 * logout description
 * gmi service call to log the user out
 * @param {boolean} loadingOverlay - whether a loading overlay should be shown while the service call runs
 * @return {Promise}
 */
export const logout = ({ loadingOverlay = false } = {}) => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.profile.logout,
      }),
      timeout: true,
      loadingOverlay,
      onComplete: response => {
        if (!response.messages) {
          // Setting custom redirect to null so unauth user will be redirected to timeout page
          utils.timeoutRedirect.setCustomRedirect(null);
        }
      },
    })
  );
